<template>
  <!-- dialog - 上传图片链接 -->
  <zt-dialog
    class="dialog"
    :title="`上传${typeCn}链接`"
    :visible.sync="visibleInside"
    :modal="modal"
    :append-to-body="true"
    :modal-append-to-body="false"
  >
    <div class="title">请输入{{typeCn}}链接：</div>
    <zt-textarea v-model="linkStr" type="textarea" rows="6" :placeholder="`${typeCn}链接`"></zt-textarea>
    <div class="sub-desc">*多个{{typeCn}}链接可用逗号隔开</div>
    <zt-tip :msg="msg" type="error"></zt-tip>

    <div slot="footer" class="dialog-footer">
      <zt-button @click="changeVisible(false)" class="mr10">取 消</zt-button>
      <zt-button type="primary" @click="confirm" :loading="submitLoading">
        确 定
        <template slot="loading">正在提交...</template>
      </zt-button>
    </div>
  </zt-dialog>
</template>

<script>
import { validateImage, validateVideo } from '@/utils/validate';

import ZtTextarea from '@cps/ZtTextarea';
import ZtDialog from '@cps/ZtDialog';
import ZtTip from '@cps/ZtTip';

export default {
  name: 'UploadDialogLink',
  components: {
    ZtTextarea,
    ZtDialog,
    ZtTip,
  },

  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    type: {
      // 类型: image / video
      type: String,
      default: 'image',
    },

    // 蒙版
    modal: {
      type: Boolean,
      default: true,
    },
  },

  data: () => ({
    linkStr: '',
    linkArr: [],
    msg: '',
    visibleInside: false,
    submitLoading: false,
  }),

  computed: {
    typeCn() {
      return this.type === 'image' ? '图片' : '视频';
    },
  },

  /* 
    >> 测试图片
    http://192.168.0.126:9575/?#/contentmanage/editgoods/123?,
    https://img.alicdn.com/i2/2935711448/O1CN01YjeutM1MZDz1suoZ6_!!2935711448.jpg,
    https://img.alicdn.com/i4/2935711448/O1CN01v2fS9p1MZDz6ClZzi_!!2935711448.jpg,
    https://img.alicdn.com/i4/2935711448/O1CN01BdPJnl1MZDzAOGrCy_!!2935711448.jpg, 
  */

  watch: {
    visible() {
      this.visibleInside = this.visible;
    },
    visibleInside() {
      this.$emit('update:visible', this.visibleInside);
    },
  },

  methods: {
    // 上传图片链接 - 点击确定
    async confirm() {
      this.submitLoading = true;

      this.strToArr();
      this.filterBlank();
      this.formatLink();
      var errLinks;
      switch (this.type) {
      case 'image':
        errLinks = await this.filterImageError();
        break;

      case 'video':
        errLinks = await this.filterVideoError();
        break;
      }

      this.submitLoading = false;
      if (this.linkArr.length >= 1) {
        // 无效链接提示
        if (errLinks.length) {
          errLinks = errLinks.map((v, k) => {
            return `\n>${k + 1}: ${v}`;
          });
          let text = errLinks.join('');
          this.$message({
            type: 'error',
            message: `已为您过滤部分无效的链接${text}`,
          });
        }
        this.$emit('change', this.arrToArrObj(this.linkArr));
        this.linkStr = '';
        this.changeVisible(false);
      } else {
        this.msg = `无法获取链接${this.typeCn}，请重新输入`;
      }
    },

    strToArr() {
      // 转换 - 多个图片链接可用逗号隔开
      this.linkArr = this.linkStr.split(/,|，/);
    },

    // 过滤空白
    filterBlank() {
      // Trim
      this.linkArr = this.linkArr.map((v) => {
        return v.replace(/^\s+|\s+$/g, '');
      });
      // 过滤 - 空
      this.linkArr = this.linkArr.filter((v) => {
        return v;
      });
    },

    // https://img.alicdn.com/imgextra/i4/3522219942/O1CN012NJU9OIKyv30IZ1_!!3522219942-0-item_pic.jpg_430x430q90.jpg

    // 过滤无法加载
    async filterImageError() {
      var validateArr = [];
      var errLinks = [];
      // 过滤 - 非图片
      this.linkArr.forEach((v) => {
        validateArr.push(validateImage(v));
      });
      await Promise.all(validateArr).then((resultList) => {
        this.linkArr = this.linkArr.filter((v, k) => {
          if (resultList[k] === false) {
            errLinks.push(v);
          }
          return resultList[k];
        });
      });
      return errLinks;
    },

    // cloud.video.taobao.com/play/u/4061108129/p/1/e/6/t/1/216249773208.mp4,https://tbm-auth.alicdn.com/rccy0o3Q7lTpt2pFOBn/POu0YaMbUu0clmyPTri_216249773208_hd_hq.mp4?auth_key=1548127639-0-0-5defa1d93e72c3e44d85bbf45a796e65

    async filterVideoError() {
      var validateArr = [];
      var errLinks = [];
      // 过滤 - 错误链接
      this.linkArr.forEach((v) => {
        validateArr.push(validateVideo(v));
      });
      await Promise.all(validateArr).then((resultList) => {
        this.linkArr = this.linkArr.filter((v, k) => {
          if (resultList[k] === false) {
            errLinks.push(v);
          }
          return resultList[k];
        });
      });
      return errLinks;
    },

    formatLink() {
      console.log(this.linkArr);
      this.linkArr = this.linkArr.map((src) =>
        src.replace(/^http(s*)(:*)(\/*)/, '').replace(/^/, '//')
      );
      console.log(this.linkArr);
    },

    // 数组转数组对象
    arrToArrObj(arr) {
      return arr.map((v) => {
        return { src: v, id: new Date().getTime(), selected: true };
      });
    },

    // 改变 - 可见
    changeVisible(boole) {
      this.visibleInside = boole;
    },
  },
};
</script>

<style lang="scss" scoped>
.dialog {
  .title {
    font-size: 16px;
    line-height: 44px;
    margin-bottom: 1px;
    color: $theme-textnormal;
  }
  .sub-desc {
    font-size: 12px;
    line-height: 17px;
    margin-top: 8px;
    color: $theme-textplaceholder;
  }
  .zt-tip {
    margin-top: 8px;
  }
}
</style>